import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip, Col, Row } from 'react-bootstrap';
import DropDown from '../../../../../../../components/DropDown';
import { faQuestionCircle, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import DatePicker from 'react-date-picker';
import moment from 'moment';
import { useReportContext } from '../../../../../../reports/components/reportContext';
import { useSelector } from 'react-redux';
import { selectCurrentUserData } from '../../../../../../../features/authentication/authSlice';

function ReportOptions(props) {
  const reportContext = useReportContext();
  const [minDate, setMinDate] = useState(new Date(reportContext?.startDate));
  const [maxDate, setMaxDate] = useState(new Date(reportContext?.endDate));
  const [schoolDateRange, setSchoolDateRange] = useState(null);
  const user = useSelector(selectCurrentUserData);

  useEffect(() => {
    if(props?.showTimePeriod){
      try{
        setSchoolDateRange({
          startDate: new Date(user.SchoolInfo.StartDate),
          endDate: new Date(user.SchoolInfo.EndDate)
        });
      } catch{
        var currentYear = new Date().getFullYear();
        setSchoolDateRange({
          startDate: new Date(currentYear, 7,1),
          endDate: new Date(currentYear, 6, 30)
        })
      }
    }
  },[]);

  const reportInputs = <div className="d-flex gap-3 mb-3">
    {props?.showTimePeriod &&
      <>
        <div className="d-flex flex-column custom_input w-100">
          <div className="mb-3 assign-settings-header">From</div>
          <div className="date-time-picker">
            <DatePicker
              onChange={(dateValue) => handleDateChange(dateValue, 'fromDate')}
              value={new Date(reportContext?.startDate.replace(/-/g, '\/'))}
              minDate={schoolDateRange?.startDate}
              maxDate={maxDate}
              format="MM-dd-yyyy"
              className="d-flex"
              id="initial-from-date-picker"
              calendarIcon={<FontAwesomeIcon icon={faCalendarDays} color='#7D7D7D' style={{ fontSize: '1.35em', marginLeft: '1em' }} />}
              clearIcon={null}
            />
          </div>
        </div>
        <div className="d-flex flex-column custom_input w-100">
          <div className="mb-3 assign-settings-header">To</div>
          <div className="date-time-picker">
            <DatePicker
              onChange={(dateValue) => handleDateChange(dateValue, 'toDate')}
              value={new Date(reportContext?.endDate.replace(/-/g, '\/'))}
              minDate={minDate}
              maxDate={schoolDateRange?.endDate}
              format="MM-dd-yyyy"
              className="d-flex"
              id="initial-to-date-picker"
              calendarIcon={<FontAwesomeIcon icon={faCalendarDays} color='#7D7D7D' style={{ fontSize: '1.35em', marginLeft: '1em' }} />}
              clearIcon={null}
            />
          </div>
        </div>
      </>
    }

    <div className="d-flex flex-column custom_input w-100">
      <label style={{ marginBottom: '13px' }}>
        Scoring Threshold
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip className="custom-tooltip">
              This is the score that will determine the cutoff for the blue/red bars.
            </Tooltip>
          }>
          <FontAwesomeIcon className="ms-1" color="#88CBF1" icon={faQuestionCircle} />
        </OverlayTrigger>
      </label>

      <input
        className="form-control"
        onChange={(e) =>
          props?.additionOptionInputValueHandler(e.target.value, 'passingScore')
        }
        defaultValue={props?.sessionReportOptions?.passingScore}
        value={props?.sessionReportOptions?.passingScore}
      />
    </div>
    <div className="d-flex flex-column custom_input position-relative w-100">
      {props?.showRetryOptions &&
        <>
          <DropDown
            label="Correct-On-Retry Scoring"
            value={props.allCredits}
            onChangeHandler={(e) => props.handleSelectCredits(e)}
            selectedValue={props?.selectedCreditId}
            dropDownId="creditDropDown"
          />
          <input
            type="text"
            id="creditNameTextBox"
            className="form-control d-none"
            defaultValue={props.creditName}></input>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip className="custom-tooltip">
                This determines how the retry scores are calculated.
              </Tooltip>
            }>
            <FontAwesomeIcon
              className="ms-1 position-absolute"
              style={{
                top: '5px',
                left: '180px'
              }}
              color="#88CBF1"
              icon={faQuestionCircle}
            />
          </OverlayTrigger>
        </>
      }
    </div>

  </div>

  const handleDateChange = (dateValue, date) => {
    var formattedDate = moment(dateValue).format('yyyy-MM-DD');
    if (date == 'fromDate') {
      reportContext.setStartDate(formattedDate);
    } else {
      reportContext.setEndDate(formattedDate);
    }
    props.handleReportDateChange(dateValue, date);
  };

  useEffect(() => {

    var newMinDate = new Date(reportContext?.startDate.replace(/-/g, '\/'));
    newMinDate.setDate(newMinDate.getDate() + 1);
    setMinDate(newMinDate);

    var newMaxDate = new Date(reportContext?.endDate.replace(/-/g, '\/'));
    newMaxDate.setDate(newMaxDate.getDate() - 1);
    setMaxDate(newMaxDate);
  }, [reportContext?.startDate, reportContext?.endDate]);

  return (
    props?.expand && (
      <div className="mt-3 report_option_details fade show flex-column">
        {props?.showTimePeriod && reportInputs}

        <div className='d-flex flex-row'>
          <div className="leftSide">
            {!props?.showTimePeriod && <>
              <h5 className="mb-4">Report Options</h5>
              {reportInputs}
            </>}

            <div className="d-flex flex-column">
              <p className="mb-3">
                By default, all students who have started this assignment will show in this report.
                Additional options:
              </p>
              {props?.checkBoxInput?.map((item) => (
                <div key={item.id} className="d-flex gap-1 flex-row">
                  <input
                    key={item.id}
                    type="checkbox"
                    id={item.id}
                    className="form-check-input border-secondary"
                    checked={props.sessionReportOptions[item.id]}
                    onChange={() => props.handleCheckBonInput(item.id)}
                  />

                  <label htmlFor={item.id}>{item.label} </label>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip className="custom-tooltip">{item.toolTip}</Tooltip>}>
                    <FontAwesomeIcon className="ms-1" color="#88CBF1" icon={faQuestionCircle} />
                  </OverlayTrigger>
                </div>
              ))}
            </div>
            {props.showQuestionCategory &&
              <>
                <Row className="pt-2 mt-2">
                  <Col className='col-2 d-flex gap-2'>
                    <input
                      type="radio"
                      className="form-check-input cursor-pointer border-secondary"
                      checked={props.questionCategory === 0}
                      id="assigned"
                      name="questionCategoryRadioBtn"
                      onChange={() => { props.setQuestionCategory(0); props.handleQuestionCategory(0); }}
                    />
                    <label className="form-check-label">
                      Assigned
                    </label>
                  </Col>
                  <Col className='col-3 d-flex gap-2'>
                    <input
                      type="radio"
                      className="form-check-input cursor-pointer border-secondary"
                      checked={props.questionCategory === 1}
                      id="selfgenerated"
                      name="questionCategoryRadioBtn"
                      onChange={() => { props.setQuestionCategory(1); props.handleQuestionCategory(1); }}
                    />
                    <label className="form-check-label">
                      Self-Generated
                    </label>
                  </Col>
                  <Col className='col-3 d-flex gap-2'>
                    <input
                      type="radio"
                      className="form-check-input cursor-pointer border-secondary"
                      checked={props.questionCategory === 2}
                      id="all"
                      name="questionCategoryRadioBtn"
                      onChange={() => { props.setQuestionCategory(2); props.handleQuestionCategory(2); }}
                    />
                    <label className="form-check-label">
                      All
                    </label>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip className="custom-tooltip">Select a report option to include assigned questions, self-generated questions, or all questions answered.</Tooltip>}>
                      <FontAwesomeIcon className="ms-1" color="#88CBF1" icon={faQuestionCircle} />
                    </OverlayTrigger>
                  </Col>
                </Row>
              </>
            }
          </div>
          <div className="right-side">
            <p>Check to include in report</p>

            <div className="d-flex flex-row gap-5">
              <div className="d-flex flex-column">
                {props?.includeReportCheckBox[0]?.map((item, index) => (
                  <>
                    {!item.hide &&
                      <div className="d-flex flex-row gap-1" key={index}>
                        <input
                          type="checkbox"
                          onChange={() => props.reportChangeHandler(item.id)}
                          id={item.id}
                          checked={props.sessionReportOptions[item.id]}
                          className="form-check-input border-secondary"
                        />
                        <label htmlFor={item.id}>{item.label}</label>
                      </div>
                    }
                  </>
                ))}
              </div>

              <div className="d-flex flex-column">
                {props?.includeReportCheckBox[1]?.map((item, index) => {
                  if (item.id === 'answerDistribution' && !props.sessionReportOptions?.questions) {
                    return null; // Skip rendering "Answer Distribution" checkbox if "Attributes" is not checked
                  }
                  return (
                    <>
                      {!item.hide &&
                        <div key={index} className="d-flex flex-row gap-1">
                          <input
                            type="checkbox"
                            checked={props.sessionReportOptions[item.id]}
                            onChange={(e) => props.reportChangeHandler(item.id, e.target.checked)}
                            id={item.id}
                            className="form-check-input border-secondary"
                          />
                          <label htmlFor={item.id}>{item.label}</label>
                        </div>
                      }
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
}

ReportOptions.propTypes = {
  key: PropTypes.string,
  expand: PropTypes.bool,
  checkBoxInput: PropTypes.array,
  includeReportCheckBox: PropTypes.array,
  reportChangeHandler: PropTypes.func,
  handleCheckBonInput: PropTypes.func,
  sessionReportOptions: PropTypes.object,
  handleSelectCredits: PropTypes.func,
  allCredits: PropTypes.array,
  selectedCreditId: PropTypes.number,
  setSelectedCreditId: PropTypes.func,
  additionOptionInputValueHandler: PropTypes.func,
  creditName: PropTypes.string,
  showRetryOptions: PropTypes.bool,
  singleStudent: PropTypes.bool,
  showQuestionCategory: PropTypes.bool,
  setQuestionCategory: PropTypes.func,
  questionCategory: PropTypes.number,
  handleQuestionCategory: PropTypes.func
};
export default ReportOptions;
